var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StreamChatCtrl',{attrs:{"username":_vm.username},on:{"on-clear-chat":_vm.onClearChat}})
}
var staticRenderFns = []

export { render, staticRenderFns }